import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLopacityHalfIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M2.26999 6.75999C1.75999 6.53999 1.16999 6.77999 0.959994 7.28999C0.679994 7.94999 0.459994 8.63999 0.299994 9.33999C0.179994 9.87999 0.519994 10.41 1.04999 10.54C1.56999 10.66 2.12999 10.33 2.24999 9.78999C2.37999 9.20999 2.56999 8.62999 2.79999 8.08999C3.01999 7.57999 2.77999 6.98999 2.26999 6.77999V6.75999Z"
        fill={color}
      />
      <path
        d="M5.83002 1.71C5.22002 2.08 4.63002 2.5 4.09002 2.98C3.67002 3.34 3.63002 3.98 4.00002 4.39C4.37002 4.81 5.00002 4.85 5.41002 4.48C5.86002 4.09 6.35002 3.73 6.86002 3.42C7.33002 3.14 7.49002 2.52 7.20002 2.05C6.92002 1.58 6.30002 1.42 5.83002 1.71Z"
        fill={color}
      />
      <path
        d="M2.25001 14.22C2.13001 13.68 1.58001 13.34 1.05001 13.47C0.510006 13.59 0.170006 14.13 0.300006 14.67C0.460006 15.37 0.680006 16.06 0.960006 16.72C1.18001 17.23 1.76001 17.46 2.27001 17.25C2.78001 17.03 3.01001 16.44 2.80001 15.94C2.57001 15.39 2.38001 14.82 2.25001 14.24V14.22Z"
        fill={color}
      />
      <path
        d="M6.86002 20.58C6.35002 20.27 5.86002 19.92 5.41002 19.52C5.00002 19.16 4.36002 19.2 4.00002 19.61C3.64002 20.03 3.68002 20.66 4.09002 21.02C4.63002 21.49 5.21002 21.92 5.83002 22.29C6.30002 22.57 6.92002 22.42 7.20002 21.95C7.48002 21.48 7.33002 20.86 6.86002 20.58Z"
        fill={color}
      />
      <path
        d="M12 0C11.45 0 11 0.45 11 1V23C11 23.55 11.45 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLopacityHalfIcon.displayName = 'HierLopacityHalfIcon';
